import { Typography, Button } from '@ui/components';
import { Cancel, Info } from '@ui/components/icons';
import { cva } from 'class-variance-authority';

import { useTopbarConfiguration } from './use-topbar-configuration';

export const TopbarVariants = cva('flex items-center justify-center gap-3 p-2 shadow-2xs pr-16', {
  variants: {
    variant: {
      warning: 'bg-warning',
      critical: 'bg-critical text-contrast',
      info: 'bg-surface text-contrast',
    },
  },
  defaultVariants: {
    variant: 'warning',
  },
});

export const Topbar = () => {
  const { isTopbarVisible, setIsTopbarVisible, topbarData } = useTopbarConfiguration();

  if (!isTopbarVisible || !topbarData) return null;

  return (
    <div className={TopbarVariants({ variant: topbarData.variant })}>
      <Info />
      <Typography variant="h100">{topbarData.title}</Typography>
      <Button variant={topbarData.ctaVariant} onClick={topbarData.ctaAction}>
        {topbarData.ctaLabel}
      </Button>

      <Button
        onClick={() => setIsTopbarVisible(false)}
        className="absolute right-4"
        variant="ghost"
        icon
      >
        <Cancel />
      </Button>
    </div>
  );
};
